import { type FC } from 'react';

import { isLastListItem } from '@/packages/utils/array';

import { type IMarkedListSchema } from '@/repositories/generated/shared/search-offers/entities/seo/MarkedListSchema';

import { Accordion } from './internal/components/Accordion';

import styles from './MarkedList.css';

type MarkedListProps = {
  items: IMarkedListSchema[];
};

export const MarkedList: FC<MarkedListProps> = props => {
  const { items } = props;

  return (
    <div className={styles['container']} data-testid="seo.marked-list">
      {items.reduce((accumulator, item, index, arr) => {
        const { content, title } = item;

        const id = `SeoMarkedListItem_${index}`;

        if (content && title) {
          const headingId = `${id}_heading`;
          const bodyId = `${id}_body`;

          accumulator.push(
            <Accordion
              bodyId={bodyId}
              bottomBorder={!isLastListItem(arr, index)}
              content={content}
              headingId={headingId}
              key={`${content}${title}`}
              title={title}
            />,
          );
        }

        return accumulator;
      }, Array.of<JSX.Element>())}
    </div>
  );
};
